"use client";

import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats = [{
  value: "450+",
  label: "Bespoke Events"
}, {
  value: "320+",
  label: "Happy Couples"
}, {
  value: "15+",
  label: "Years of Artistry"
}, {
  value: "85+",
  label: "Luxury Partners"
}];
export default function CelebrationMilestones() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223716" id="celebration-milestones" className="bg-background text-foreground relative flex flex-col items-center justify-center py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-10" style={{
      backgroundImage: `
            linear-gradient(to right, var(--color-border) 1px, transparent 1px),
            linear-gradient(to bottom, var(--color-border) 1px, transparent 1px)
          `,
      backgroundSize: "40px 40px"
    }} aria-hidden="true" />

      {}
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20">
        <Separator className="bg-gradient-to-r from-transparent via-border to-transparent h-px border-0" />
      </div>

      <div ref={ref} className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 text-center">
          {stats.map((stat, i) => <div key={i} data-index={i} className={`flex flex-col items-center justify-center space-y-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <div className="relative inline-block">
                {}
                <div className="absolute inset-0 bg-accent/40 blur-3xl rounded-lg scale-150" aria-hidden="true" />
                <span className="relative font-serif text-5xl sm:text-6xl lg:text-7xl font-medium text-primary tracking-tight">
                  {stat.value}
                </span>
              </div>
              <span className="font-default text-xs sm:text-sm text-muted-foreground uppercase tracking-widest font-semibold">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>

      {}
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-20">
        <Separator className="bg-gradient-to-r from-transparent via-border to-transparent h-px border-0" />
      </div>
    </section>;
}